
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectWS","sendEvent","closeWS","test"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "c6d932552c029abca368.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "c6d932552c029abca368.worker.js");
					addMethods(w, methods)
					
					return w
				}
			